// extracted by mini-css-extract-plugin
module.exports = {"img":"TranslationProduct_img__213pj","wrap":"TranslationProduct_wrap__15c6U","otherImages":"TranslationProduct_otherImages__3GNqr"};